import { css } from '@emotion/react';
import { flex } from '@spotnana/blocks/src/utils';

export const white_label_config_loader = css`
  ${flex.init}
  ${flex.align.center}
  ${flex.justify.center}
  height: calc(100vh - 5rem);
`;
